import React from 'react';
import './PlayListMain.scss';
import { useDataLayerValue } from '../../DataLayer';
import { FORMAT_TIME } from '../../constants/format';

function PlayListMain(props) {
    const [{ lang }] = useDataLayerValue();
    const playDetail = props.type && props.type === 'playlist' ? { ...props.playListDetail, type: props.type } : { ...props.songDetail, type: props.type };
    const countSongs = props.countSongs && props.countSongs > 0 ? props.countSongs : 0;
    const countTimes = props.countTimes && props.countTimes > 0 ? props.countTimes : 0;
    const typeLang = {
        en: {
            playlist: 'Playlist',
            song: 'Song',
            countSong: 'songs',
            countTime: 'Time'
        },
        vi: {
            playlist: 'Danh sách',
            song: 'Bài hát',
            countSong: 'bài hát',
            countTime: 'Thời gian'
        }
    };
    return (
        <div className="playlist-main" style={{ backgroundImage: `url(${playDetail.cover ? playDetail.cover : ''})`, backgroundColor: `${playDetail.bg_color ? playDetail.bg_color : '#121212'}` }}>

            <div className="playlist-main--warp">
                <div className="playlist-image" >
                    <img aria-hidden="false" draggable="false" loading="eager" className={ playDetail.border_radius ? 'border-radius-50' : ''} style={{ boxShadow: `0px 4px 60px rgba(0  ,0 ,0, 0.5) , 0px 4px 30px ${playDetail.bg_color}` }} src={playDetail.avatar ? playDetail.avatar : ''} alt={lang === 'en' ? playDetail.name_en : playDetail.name_vi} />
                </div>
                <div className="playlist-content">
                    <h2>{lang === 'en' ? (playDetail.type === 'playlist' ? typeLang.en.playlist : typeLang.en.song) : (playDetail.type === 'playlist' ? typeLang.vi.playlist : typeLang.vi.song)}</h2>
                    <h1>{lang === 'en' ? playDetail.name_en : playDetail.name_vi}</h1>
                    <p><span>{playDetail.type === 'song' && playDetail.singer ? `${playDetail.singer} | ` : ''}</span><span>{lang === 'en' ? playDetail.subtitle_en : playDetail.subtitle_vi}</span></p>
                    <div><span>{countSongs ? countSongs : '0'} {lang === 'en' ? typeLang.en.countSong : typeLang.vi.countSong} | </span> <span> {lang === 'en' ? typeLang.en.countTime : typeLang.vi.countTime}:  {countTimes ? FORMAT_TIME(countTimes) : '00:00'}</span></div>
                </div>
            </div>
        </div>
    );
}

export default PlayListMain;